export default {
    byKeyword(id) {
        return this.transformer.many(
            this.try(
                this.baseQuery().where('keywordId', id).get()
            )
        )
    }
}
